import { Permission } from 'shared'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { TestingLab, useTestingLabsContext } from '../../TestingLabsContext'
import { useGlobalState } from 'context/GlobalStateContext'
import { useCreateTestingLabMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import CreateEditBody from '../components/CreateEditBody'
import { CreateEditTestingLabValues } from '../components/CreateEditBody/types'
import { errorHandler } from '../../../../../../../../../../../hooks/errorHandler'

export function useCreate(): CreateHeaderActionOptions<TestingLab> {
  const { fetching, refetch } = useTestingLabsContext()
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const [create] = useCreateTestingLabMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createTestingLab: {
        testingLab: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    entity: 'Testing Lab',
    permission: Permission.CreateTestingLab,
    loading: fetching,
    modal: {
      type: 'simple',
      body: <CreateEditBody />,
      onOk: async ({ labTechs, name }: CreateEditTestingLabValues) => {
        if (!projectId) return errorHandler('projectId is not defined')
        await create({
          variables: {
            input: {
              projectId,
              name,
              labTechIds: labTechs
                ? labTechs.map(({ value }) => value as number)
                : undefined,
            },
          },
        })
        refetch()
      },
    },
  }
}
